import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import Container from './styles/Container';
import formatFloatNum from '../../../../../../shared/utils/floatFormatter';

function SensorTile({ sensor = {} }) {
  const { value, name, units } = sensor;
  const displayValue = typeof value === 'number' ? formatFloatNum(value, 2, 'ru-RU') : value || '–';

  return (
    <Container>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ lineHeight: 1.2, textAlign: 'start', width: '100%', height: '40px' }}
      >
        {name}
      </Typography>

      <Typography variant="h6" align="center" sx={{ fontWeight: 500, fontSize: '14px' }}>
        {displayValue}
      </Typography>

      <Typography sx={{ fontSize: '11px' }} variant="caption" color="text.secondary" align="right">
        {units || ''}
      </Typography>
    </Container>
  );
}

SensorTile.propTypes = {
  sensor: PropTypes.shape({
    name: PropTypes.string.isRequired,
    units: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    sendTime: PropTypes.number,
  }).isRequired,
};

export default SensorTile;
